<template>
  <div
    v-if="showLoadingState < 4"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingProyectDetail"
  >
    <div class="m-edition-proyect-details-info">
      <div class="m-edition-billing-proyect-details-info-left">
        <div class="m-edition-billing-proyect-details-info-body">
          <h4>{{ $t('mEditionBillingProyectDetails.infoLeft.title') }}</h4>
          <p>
            <span class="info-icon-left info-icon-billing margin-right-small">
              <i class="fas fa-folder-open"></i>
            </span>
            <span>
              {{  proyecto.titulo }}
            </span>
          </p>
          <p>
            <span class="info-icon-left info-icon-billing margin-right-small">
              <i class="fas fa-text"></i>
            </span>
            <span class="width-fit-content">
              {{  proyecto.descripcion }}
            </span>
          </p>
          <p>
            <span class="info-icon-left info-icon-billing margin-right-small">
              <i class="fas fa-eye"></i>
            </span>
            <span>
              {{ $t('mEditionBillingProyectDetails.infoLeft.proyectType') }}
              <span v-if="proyecto.tipo">
                Curso,
              </span>
              <span v-else>
                Mapa,
              </span>
              en estado
              <span v-if="proyecto.publicado">
                publicado
              </span>
              <span v-else>
                borrador
              </span>
            </span>
          </p>
          <p>
            <span class="info-icon-left info-icon-billing margin-right-small">
              <i class="fas fa-calendar-alt"></i>
            </span>
            <span>
              {{ $t('mEditionBillingProyectDetails.infoLeft.activationDate') }}
              <span v-if="proyecto.fecha_inicio">
                {{ $moment.parseZone(proyecto.fecha_inicio).format('D MMMM, YYYY') }}
              </span>
              <span v-else>
                inmediata
              </span>
            </span>
          </p>
          <p>
            <span class="info-icon-left info-icon-billing margin-right-small">
              <i class="fas fa-users"></i>
            </span>
            <span>
              {{ cantindadAlumnos + ' ' + $t('mEditionBillingProyectDetails.infoLeft.activeStudents')}}
            </span>
          </p>
          <p>
            <span class="info-icon-left info-icon-billing margin-right-small">
              <i class="fas fa-comments"></i>
            </span>
            <span>
              {{  cantidadPreguntasPendientes + ' ' +  $t('mEditionBillingProyectDetails.infoLeft.pendingMessages') }}
            </span>
          </p>
        </div>
      </div>
      <div class="m-edition-billing-proyect-details-info-right">
        <CardDesign2 :proyecto="proyecto"/>
      </div>
    </div>
    <h4 class="font-weight-bold">{{ $t('mEditionBillingProyectDetails.contentTitle') }}</h4>
    <p v-if="nodos.length === 0">Aún no se han creado contenidos para este proyecto.</p>
    <div class="m-edition-billing-contents">
      <MoleculeEditionBillingContentsTreeNode
        v-for="nodo in nodos"
        :key="nodo.id"
        :contenido="version"
        :element="proyecto"
        :info="{ nodosActivos: Object.assign({}, nodosActivos) }"
        :is-child="false"
        :nodo="nodo"
        node-actions="ActivationInmediate"
        node-actions-class="displayed"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'MoleculeEditionBillingAcademyProyectsDetails',

  components: {
    CardDesign2: () => import('@/components/molecules/MoleculeEditionBillingAcademyProyectCard2'),
    MoleculeEditionBillingContentsTreeNode: () => import('@/components/molecules/MoleculeEditionBillingContentsTreeNode')
  },

  data () {
    return {
      cantindadAlumnos: 0,
      cantidadPreguntasPendientes: 0,
      diasNodos: {},
      entregablesProyecto: {},
      nodos: [],

      nodosActivos: {
        academia: '',
        nodos: []
      },

      proyecto: {},
      showLoadingState: 0,
      version: 0
    }
  },

  created () {
    this.readProyecto()
    this.readProgresoAlumnos()
    this.readContenidos()
  },

  methods: {
    readCantidadPreguntasPendientes () {
      this.$services.read('contenido', 'readContenidoPreguntasPendientes', {}, [this.version.id])
        .then(response => {
          this.cantidadPreguntasPendientes = response.data.contenido
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readContenidos () {
      this.$services.read('contenido', 'readContenidos', {}, [this.$route.params.subid])
        .then(response => {
          this.version = response.data[0]
          this.readCantidadPreguntasPendientes()
          this.readContenidoEntregables()
        })
        .catch(error => {
          console.log(error)
        })
    },

    readContenidoEntregables () {
      this.$services.read('contenido', 'readContenidoEntregables', {}, [this.version.id], this.filters)
        .then(response => {
          this.entregablesProyecto = response.data.entregables
          this.readContenidoNodos()
        })
        .catch(error => {
          console.log(error)
        })
    },

    readContenidoNodos () {
      this.$services.read('contenido', 'readContenidoNodos', {}, [this.version.id])
        .then(response => {
          this.nodos = response.data
          this.nodos.forEach(nodo => {
            this.setNodosActivos(nodo)
          })
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    setNodosActivos (nodo) {
      this.nodosActivos.nodos.push({ nodo: nodo.id, dia: -1 })

      for (let i = 0; i < this.entregablesProyecto.length; i++) {
        if (this.entregablesProyecto[i].tipo === 'nodo' &&
          this.entregablesProyecto[i].nodos.length > 0 &&
          this.entregablesProyecto[i].nodos.find(enodo => enodo.nodo === nodo.id)) {
          this.nodosActivos.nodos[this.nodosActivos.nodos.length - 1].dia = this.entregablesProyecto[i].dia
          break
        }
      }

      if (nodo.children.length > 0) {
        nodo.children.forEach(child => {
          this.setNodosActivos(child)
        })
      }
    },

    readProgresoAlumnos () {
      this.$services.read('proyecto', 'readProyectoProgresoAlumnos', {}, [this.$route.params.subid])
        .then(response => {
          this.cantindadAlumnos = response.data.progreso_alumnos.alumnos_activos_proyecto
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readProyecto () {
      this.$services.read('proyecto', 'readProyecto', {}, [this.$route.params.subid])
        .then(response => {
          this.proyecto = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}

</script>
